import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BlockJustify } from '../../../../models/BlockSettings';

interface BlockJustifyPickerProps {
  value: BlockJustify;
  direction: 'row' | 'column';
  onChangeJustify: (value: BlockJustify) => void;
  isFooter?: boolean;
  hasExtraJustifyments?: boolean;
}

const BlockJustifyPicker = ({
  value,
  direction,
  onChangeJustify,
  isFooter = false,
  hasExtraJustifyments = true,
}: BlockJustifyPickerProps) => {
  const handleTextToDisplay = () => {
    if (isFooter) {
      return 'Menu position';
    }

    if (direction === 'column') {
      return 'Vertical position';
    }

    return 'Horizontal position';
  };

  if (isFooter) {
    return (
      <>
        {handleTextToDisplay()}

        <ToggleButtonGroup
          color="primary"
          value={value}
          exclusive
          onChange={(_, newValue: BlockJustify) => {
            if (newValue) {
              onChangeJustify(newValue);
            }
          }}
          size="small"
          sx={{ marginLeft: 3 }}
        >
          <ToggleButton value={BlockJustify.START} sx={{ paddingX: 2, paddingY: 1 }}>Left</ToggleButton>
          <ToggleButton value={BlockJustify.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>Center</ToggleButton>
          <ToggleButton value={BlockJustify.END} sx={{ paddingX: 2, paddingY: 1 }}>Right</ToggleButton>
        </ToggleButtonGroup>
      </>
    );
  }

  if (!hasExtraJustifyments) {
    return (
      <>
        {handleTextToDisplay()}

        <ToggleButtonGroup
          color="primary"
          value={value}
          exclusive
          onChange={(_, newValue: BlockJustify) => {
            if (newValue) {
              onChangeJustify(newValue);
            }
          }}
          size="small"
          sx={{ marginLeft: 3 }}
        >
          <ToggleButton value={BlockJustify.START} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Top' : 'Left'}</ToggleButton>
          <ToggleButton value={BlockJustify.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Center' : 'Center'}</ToggleButton>
          <ToggleButton value={BlockJustify.END} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Bottom' : 'Right'}</ToggleButton>
        </ToggleButtonGroup>
      </>
    );
  }

  return (
    <Box>
      {handleTextToDisplay()}

      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={
          (_, newValue: BlockJustify) => {
            if (newValue) {
              onChangeJustify(newValue);
            }
          }
        }
        size="small"
        sx={{ marginLeft: 3 }}
      >
        <ToggleButton value={BlockJustify.START} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Top' : 'Left'}</ToggleButton>
        <ToggleButton value={BlockJustify.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Center' : 'Center'}</ToggleButton>
        <ToggleButton value={BlockJustify.END} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Bottom' : 'Right'}</ToggleButton>
        <ToggleButton value={BlockJustify.SPACE_BETWEEN} sx={{ paddingX: 2, paddingY: 1 }}>Space between</ToggleButton>
        <ToggleButton value={BlockJustify.SPACE_AROUND} sx={{ paddingX: 2, paddingY: 1 }}>Space around</ToggleButton>
        <ToggleButton value={BlockJustify.SPACE_EVENLY} sx={{ paddingX: 2, paddingY: 1 }}>Space evenly</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default BlockJustifyPicker;
